<template>
  <div class="c-auth-no">
    <Row>
      <Col span="24">
        <Card>
          <div class="c-buy-tip">
            <div class="c-buy-tip-img">
              <img src="~assets/images/icon-tip.svg" alt="" />
            </div>
            <div class="c-buy-tip-title">尚未授权</div>
            <div class="c-buy-tip-content">您尚未授权页面权限，无法查看当前内容。</div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'NoAuth'
}
</script>
<style lang="scss" scoped>
.c-auth-no {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  > div,
  .ivu-card {
    width: 100%;
    height: calc(100vh - 64px);
  }
}

.c-buy-tip {
  max-width: 500px;
  margin: 0 auto;
  padding: 220px 0 30px;
  text-align: center;

  .c-buy-tip-img > img {
    height: 100px;
    margin-bottom: 32px;
  }

  .c-buy-tip-title {
    color: #2b85e4;
    font-size: 18px;
    font-weight: 700;
  }

  .c-buy-tip-content {
    margin-top: 16px;
  }

  .c-buy-tip-btn {
    width: 200px;
    margin-top: 15px;
  }

  line-height: 1.7em;
}
</style>
